/* eslint-disable */
export default {
  participants: '參與者',
  host: '（主持人）',
  removeParticipant: '移除參與者',
  removeTitle: '移除參與者',
  removeDescription: '是否從此會議中移除 {name}？',
  confirmButtonText: '移除',
  cancelButtonText: '取消',
} as const;

// @key: @#@"participants"@#@ @source: @#@"Participants"@#@
// @key: @#@"host"@#@ @source: @#@"(Host)"@#@
// @key: @#@"removeParticipant"@#@ @source: @#@"Remove participant"@#@
// @key: @#@"removeTitle"@#@ @source: @#@"Remove participant"@#@
// @key: @#@"removeDescription"@#@ @source: @#@"Remove {name} from this conference?"@#@
// @key: @#@"confirmButtonText"@#@ @source: @#@"Remove"@#@
// @key: @#@"cancelButtonText"@#@ @source: @#@"Cancel"@#@
